/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationExclusionRulesSortCriteria {
    getFixupPrototypeFunction() { return RecommendationExclusionRulesSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<RecommendationExclusionRulesSortCriteria>): RecommendationExclusionRulesSortCriteria {
        let obj = Object.assign(new RecommendationExclusionRulesSortCriteria(), model);
        RecommendationExclusionRulesSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationExclusionRulesSortCriteria>): RecommendationExclusionRulesSortCriteria {
        if (!model) return null;
        return RecommendationExclusionRulesSortCriteria.newInstance(<RecommendationExclusionRulesSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationExclusionRulesSortCriteria) {
        if (!obj) return;

        models.RecommendationExclusionRulesSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationExclusionRulesSortCriteria): boolean {
        Object.setPrototypeOf(obj, RecommendationExclusionRulesSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.RecommendationExclusionRulesSortColumn;

    ascending: boolean;

}
